module.exports = __webpack_public_path__ + "static/media/logo.2977d2f4.png";